import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
  mark: {
    marginLeft: 5,
    display: "inline-block",
    height: 9,
    width: 9,
    flexShrink: 0,
    verticalAlign: "0.02em",
    opacity: 0.7,
  },
  announcement: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: 0,
  },
});

export function ExternalMark() {
  return (
    <>
      <svg
        {...stylex.props(styles.mark)}
        aria-hidden="true"
        viewBox="0 0 10 10"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3.4 1.2h5.4v5.4" />
        <path d="M8.8 1.2 1.4 8.6" />
      </svg>
      <span {...stylex.props(styles.announcement)}> (opens in a new tab)</span>
    </>
  );
}

export const externalLinkProps = {
  target: "_blank",
  rel: "noreferrer",
} as const;
